import { global } from '@prodelio/config/theme/styles/global';

export const styles = {
  global,
};
